export const getStrapiImageUrl = (src: string): string =>
  src.startsWith('/') ? `${process.env.NEXT_PUBLIC_STRAPI_URL}${src}` : src;
